import { useEffect, useState } from 'react'
import useGenerateText from './useGenerateText'

export const useGenerateContent = (
  ante: string,
  gameState: number,
  playerWinType: number,
  currency: string,
  totalWin: string,
  isFold: boolean,
  precision: number
): [any, boolean] => {
  const [text, settext] = useState<any>('')
  const [delay, setDelay] = useState<number>(200)
  const [content, setcontent] = useState<any>('')
  const [fadeIn, setfadeIn] = useState(false)
  useGenerateText({
    gameState,
    ante,
    text,
    setDelay,
    settext,
    playerWinType,
    currency,
    totalWin,
    isFold,
    precision
  })

  useEffect(() => {
    setfadeIn(false)
    setTimeout(() => {
      setcontent(text)
      setfadeIn(true)
    }, delay)
  }, [text, delay])

  return [content, fadeIn]
}
